<!-- Popup -->
<div class="d-flex justify-content-center align-items-center" [ngClass]="{'request-dialog-div': !minimizeDialog}">
  <!-- Modal -->
  <div class="modal-box request-dialog" *ngIf="depositData" [ngClass]="{'request-dialog-minimize': minimizeDialog}" id="request-dialog">
    <div class="modal1" id="modal-login">
      <div class="row">
          <div class="col-lg-12">
            <div class="p-t-20 p-b-20 p-30">
                <div class="modal-header row">
                  <h4 class="modal-title w-75 text-center">{{ "Payment Receipt Needed" | translate | uppercase }}</h4>
                  <button title="Close (Esc)" type="button" class="close-title" (click)="onTogglePopup()" [innerHTML]="svg.closeIcon | safeHtml"></button>
                </div>


            <mat-horizontal-stepper linear #stepper class="px-3">
              <!-- Summary of the request -->
              <mat-step>
                <div class="form-group mb-4">
                    <div class="col-12 d-flex justify-content-center mb-3">
                      <div class="receipt-icon" [innerHTML]="svg.receiptIcon | safeHtml"></div>
                    </div>
                    <label class="w-100 text-center m-b-20">{{ 'We had trouble confirming your latest deposit. Please help us with the next step.' | translate }} </label>
                    <label class="w-100 text-center">{{ 'Please upload your payment receipt so we can finish processing your deposit.' | translate }} </label>
                    <div class="details row">
                      <!-- Bank -->
                      <label class="col-4 m-0 py-1">{{ 'Bank' | translate }}</label>
                      <label class="col-1 m-0 py-1 px-0">:</label>
                      <label class="col-7 m-0 py-1 px-0">{{ depositData?.bank_name }}</label>
                      <!-- Amount -->
                      <label class="col-4 m-0 py-1">{{ 'Amount' | translate }}</label>
                      <label class="col-1 m-0 py-1 px-0">:</label>
                      <label class="col-7 m-0 py-1 px-0">{{ depositData?.currency_symbol }} {{ (depositData?.currency_code != 'IDR' ? (depositData?.amount| number : '1.0') : (depositData?.amount * 1000 | number : '1.0' : 'id-ID') ) }}</label>
                      <!-- Date/Time -->
                      <label class="col-4 m-0 py-1">{{ 'Date/Time' | translate }}</label>
                      <label class="col-1 m-0 py-1 px-0">:</label>
                      <label class="col-7 m-0 py-1 px-0">{{ depositData?.date_time | date:'yyyy-MM-dd HH:mm:ss' }}</label>
                      <!-- Reason -->
                      <label class="col-4 m-0 py-1">{{ 'Reason' | translate }}</label>
                      <label class="col-1 m-0 py-1 px-0">:</label>
                      <label class="col-7 m-0 py-1 px-0">{{ depositData?.reason ? depositData.reason : '-' }}</label>
                    </div>
                </div>
                <div class="d-flex justify-content-around">
                    <button type="button" class="main-button-1 main-button-4 w-50 mr-1 bottom-action-btn" (click)="onCancelDeposit()">{{ 'Cancel Deposit' | translate | uppercase}}</button>
                    <button type="button" class="main-button-1 w-50 ml-1 bottom-action-btn" matStepperNext>{{ 'Upload Now' | translate | uppercase}}</button>
                </div>
              </mat-step>
              <!-- Upload Receipt -->
              <mat-step>
                <form class="upload-receipt-box row m-0 p-0" id="uploadReceiptForm">
                  <div class="d-flex flex-row flex-wrap">
                    <div class="receipt-box d-flex justify-content-center align-items-center" *ngFor="let receipt of uploaded_receipts; let i = index">
                      <img *ngIf="!receipt.isPdf" [src]="receipt.path" alt="{{ 'Image Preview' | translate }}" />
                      <iframe *ngIf="receipt.isPdf" width="100%" height="100%" [src]="receipt.path" frameborder="0" style="border:0" allowfullscreen></iframe>
                      <div class="trash-img-div d-flex justify-content-end align-items-start">
                        <span (click)="onRemoveFileMulti(i)" [innerHTML]="svg.deleteIcon | safeHtml"></span>
                      </div>
                    </div>
                    <div *ngIf="uploaded_receipts.length < max_receipts" class="receipt-box d-flex justify-content-center align-items-center">
                      <input type="file" accept="image/*, application/pdf" (change)="onUploadFileMulti($event)" #myFileInput hidden/>
                      <button *ngIf="!uploadInProgress" type="button" class="upload-action-btn" (click)="myFileInput.click()" [innerHTML]="svg.uploadIcon | safeHtml"></button>
                      <span *ngIf="uploadInProgress" class="spinner-border"></span>
                    </div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="w-100 main-button-3" (click)="stepper.previous()">{{ 'Back' | translate }}</button>
                  </div>
                  <div class="col-6">
                    <button type="button" class="w-100 main-button-1" [ngClass]="form.valid ? '' : 'disabled-button'" (click)="onSubmit()">
                      <span *ngIf="formSubmitting" class="spinner-border" style="color: #000000"></span>
                      <ng-container *ngIf="!formSubmitting">{{ 'Submit Receipt' | translate }}</ng-container>
                    </button>
                  </div>
                </div>
              </mat-step>
            </mat-horizontal-stepper>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
<!-- Ballon -->
<div class="d-flex justify-content-center align-items-center" [ngClass]="{'hide-ballon': (!showBallon || depositData == null), 'receipt-floating-div': minimizeDialog, 'receipt-floating-div-hide': !minimizeDialog}" id="receipt-floating-bubble">
  <span class="badge-btn" matBadge="×" matBadgeColor="warn" (click)="onCloseBallon()" matBadgeOverlap="true"></span>
  <div class="receipt-floating-content" (click)="onTogglePopup()">
    <div class="floating-receipt-icon" [innerHTML]="svg.receiptIcon | safeHtml"></div>
  </div>
</div>
<app-swal-alert [message]="messages$ | async" [flashStyle]="true"></app-swal-alert>
